import { render } from "./pm_list.vue?vue&type=template&id=9b53ba8c&scoped=true"
import script from "./pm_list.vue?vue&type=script&lang=js"
export * from "./pm_list.vue?vue&type=script&lang=js"

import "./pm_list.vue?vue&type=style&index=0&id=9b53ba8c&lang=scss&scoped=true"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b53ba8c"]])

export default __exports__